import { oneInchPt } from './constants.js';

/**
 * Converts PostScript points to inches.
 * @param {number} pt
 * @returns {number}
 */
const convertPtToInch = pt => {
  return pt / oneInchPt;
};

export default convertPtToInch;
